module.exports = __webpack_public_path__ + "static/media/cp1.be236064.glb";